import React, { Component } from 'react';
import { API } from 'aws-amplify';
import { Button, Form, Input, Layout, Row, Col, Spin } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

const { Header, Content } = Layout;
const FormItem = Form.Item;
const ButtonGroup = Button.Group;


function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}


class Create extends Component {
    state = {
        loading: false
    }

    componentDidMount() {
        this.props.form.validateFields();
    }

    createPermissionHandler = (event) => {
        event.preventDefault();

        this.setState({loading: true});
        // TEMPORARY: hard-coded organizationKet until login mechanism is in place
        this.props.form.validateFields((err, values) => {
            if (!err) {
                API.post('benackoAPI', '/room-permissions', {
                    body: {
                        name: values.name,
                        companyId: "0b96c8f0-ac81-11e8-8d1f-390f7b6d6e9f"
                    }
                })
                .then(() => {
                    this.setState({loading: false});
                    this.props.history.goBack();
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        });
    }

    goBackHandler = () => {
        this.props.history.goBack();
    }

    render() {
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;

        // Only show error after a field is touched.
        const nameError = isFieldTouched('name') && getFieldError('name');

        return(
            <Layout>
                <Header style={{ background: '#fff', padding: 0 }}>
                    <Row>
                        <ButtonGroup>
                            <Button type="primary" onClick={this.goBackHandler}>
                                <LeftOutlined />Back
                            </Button>
                        </ButtonGroup>
                    </Row>
                </Header>
                <Content style={{ margin: 0, padding: 0, background: '#ffff' }}>
                    <Spin spinning={this.state.loading} size="large">
                        <Form onSubmit={this.createPermissionHandler} className="login-form">
                            <Row style={{marginTop: 50}}>
                                <Col span={20} offset={2}>
                                    <p>Please enter the name of the new room permission:</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={20} offset={2}>
                                    <FormItem
                                        validateStatus={nameError ? 'error' : ''}
                                        help={nameError || ''}
                                    >
                                        {getFieldDecorator('name', {
                                            rules: [{ required: true, message: 'Please input a permission name' }],
                                        })(
                                            <Input prefix={<TableOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Name" />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style={{marginTop: 20}}>
                                <Col span={4} offset={2}>
                                    <FormItem>
                                        <Button type="primary" 
                                            htmlType="submit" 
                                            disabled={hasErrors(getFieldsError())} className="login-form-button"
                                        >
                                            Create
                                        </Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Content>
            </Layout>
        );
    }
}

export default Create;